import { useEffect, useState } from "react";

function parseTimeToSeconds(time: string) {
    const [h, m, s] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
}

function formatSeconds(sec: number) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;

    return [
        String(h).padStart(2, "0"),
        String(m).padStart(2, "0"),
        String(s).padStart(2, "0")
    ].join(":");
}

export default function Countdown({ initial = "07:51:58" }) {
    const [seconds, setSeconds] = useState(parseTimeToSeconds(initial));

    useEffect(() => {
        if (seconds <= 0) return;

        const timer = setInterval(() => {
            setSeconds(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [seconds]);

    return (
        <div style={{ display: "inline-block" }}>
            {formatSeconds(seconds)}
        </div>
    );
}
